import React from 'react';
import {
  Box,
  Heading,
  SimpleGrid,
  Flex,
  Text,
  Button,
  useToast,
  Textarea,
  FormControl,
  FormLabel,
  Tag,
  Select,
} from '@chakra-ui/core';
import { FaHeart, FaRegHeart, FaEuroSign } from 'react-icons/fa';

import { connect } from 'react-redux';
import moment from 'moment';
import ReactStars from 'react-rating-stars-component';
import { useParams, useHistory } from 'react-router-dom';

import isOpen from '../components/restaurant/isOpen';
import Open from '../components/restaurant/Open';
import InfoHoraire from '../components/restaurant/InfoHoraire';

import {
  AddFavory,
  getRestaurant,
  getFavories,
  deleteFavory,
} from '../redux/actions/restAction';
import { addReview } from '../redux/actions/reviewsAction';

import { AlgoSearch } from '../redux/actions/searchAction';
import { setOrderTime } from '../redux/actions/orderTimeAction';

import Plat from '../components/restaurant/Plat';
import Head from '../util/Head';

// import MapDrawer from '../components/restaurants/MapDrawer';

function Restaurant({
  post,
  AddFavory,
  position,
  getFavories,
  auth,
  rest,
  deleteFavory,
  addReview,
  review,
  getRestaurant,
  setOrderTime,
  time,
}) {
  //   (price);
  //   const Euro = () => {
  //     for (let i = 0; i < price; i++) {
  //       return <FaEuroSign></FaEuroSign>;
  //     }
  //   };
  let day = moment().format('dddd').toLowerCase();
  let history = useHistory();

  const toast = useToast();
  let { id } = useParams();

  /////////////////////// active restaurant?////////////////////////////////

  //   let restStatus = isOpen('17:00', '18:00');
  //   let day = moment().format('dddd').toLowerCase();
  //   let restDay = post.opening_hours[date];
  //   let restStatus;
  //   let arr;
  //   let openTime;
  //   let closeTime;
  //   restStatus = restDay.map((range) => {
  //     arr = range.split('-');
  //     openTime = arr[0];
  //     closeTime = arr[1];
  //     ('openTime', openTime);
  //     ('closeTime', closeTime);
  //     return isOpen(openTime, closeTime);
  //   });
  //   let restOpen = restStatus.includes('open');
  // (restStatus);
  //   (restOpen);

  let restDay = post && post.opening_hours[day];

  let restStatus =
    restDay &&
    restDay.map(range => {
      let arr = range.split('-');
      let openTime = arr[0];
      let closeTime = arr[1];

      return isOpen(openTime, closeTime);
    });
  let restOpen = restStatus && restStatus.includes('open');
  //////////////////////////////////////////////////////////////////////

  ///////////////////////////////review section
  const [reviewObject, setReview] = React.useState({
    review: '',
    rate: '',
    restaurant_id: post && post.id,
  });
  //   (reviewObject);

  const ratingChanged = value => {
    setReview(prev => ({ ...prev, rate: value }));
  };
  const handleReviewComment = e => {
    e.persist();
    setReview(prev => ({ ...prev, review: e.target.value }));
  };
  /////////////////////////////////////////

  const [heart, setHeart] = React.useState();
  const [isfaved, setIsfaved] = React.useState(null);
  React.useEffect(() => {
    async function getData() {
      await getRestaurant(id);
      if (auth.data && !auth.loading) {
        await getFavories();
      }
    }
    getData();
    setIsfaved(
      rest.favs &&
        rest.favs.filter(fav => {
          return parseInt(fav.restaurant_id) === parseInt(id);
        })
    );
    return () => {
      setIsfaved(null);
    };
  }, [heart]);

  const days = post && Object.keys(post.opening_hours);

  const handleHeart = bol => {
    // heart ? setHeart(false) : setHeart(true);
    setHeart(bol);
  };

  let distance = null;
  if (position && post && post.latitude) {
    const R = 6371e3; // metres
    const φ1 = (post.latitude * Math.PI) / 180; // φ, λ in radians
    const φ2 = (position.latitude * Math.PI) / 180;
    const Δφ = ((position.latitude - post.latitude) * Math.PI) / 180;
    const Δλ = ((position.longitude - post.longitude) * Math.PI) / 180;

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const d = R * c; // in metres
    distance = d / 1000;
  }

  //   (isFav, heart);
  const NotLoggedinHeart = () => (
    <Box color="black">
      <FaRegHeart
        onClick={() => {
          toast({
            position: 'top-right',

            title: 'You are not logged in',
            description: 'You must login to add favorites',
            status: 'info',
            duration: 3000,
            isClosable: true,
          });
        }}
        style={{ marginRight: 15, marginTop: 15 }}
        fontSize="36px"
      ></FaRegHeart>
    </Box>
  );
  const LoggedinHeart = () => {
    if ((isfaved && isfaved.length >= 1) || heart) {
      return (
        <Box>
          <FaHeart
            onClick={async () => {
              await deleteFavory(isfaved && isfaved[0].favory_id);
              handleHeart(false);
            }}
            style={{ marginRight: 15, marginTop: 15, color: 'red' }}
            fontSize="36px"
          ></FaHeart>
        </Box>
      );
    } else {
      return (
        <Box color="black">
          <FaRegHeart
            onClick={async () => {
              await AddFavory(post.id);
              handleHeart(true);
              toast({
                position: 'top-right',

                title: 'Favorite added',
                description: 'The restaurant has been added to your favorites',
                status: 'success',
                duration: 3000,
                isClosable: true,
              });
              history.push('/favories');
            }}
            style={{ marginRight: 15, marginTop: 15 }}
            fontSize="36px"
          ></FaRegHeart>
        </Box>
      );
    }
  };

  ///////count rate/////////////////////////////
  let totalRate = 0;
  let Rate;
  post &&
    post.reviews.map(review => {
      totalRate += review.rate;
    });
  Rate = post && totalRate / post.reviews.length;
  //   (totalRate / post.reviews.length);
  ////////////////////////////////////////////////

  ////////make state of reviews//////////
  const [reviews, setReviews] = React.useState([]);
  //   (reviews);
  React.useEffect(() => {
    setReviews(post && post.reviews);
  }, []);

  ////////////////////////////////////////
  const [selectedJour, setSelectedJour] = React.useState();
  const openHours = post && Object.entries(post.opening_hours);
  const quarteHours = {
    friday: [],
    monday: [],
    sunday: [],
    thursday: [],
    tuesday: [],
    wednesday: [],
    saturday: [],
  };

  if (Symbol.iterator in Object(openHours)) {
    for (const [day, hours] of openHours) {
      hours.map(hour => {
        let arr = hour.split('-');
        let openHour = arr[0];
        let closeHour = arr[1];
        const now = moment();

        const date = now.format('YYYY-MM-DD');
        let storeOpenTime = moment(date + ' ' + openHour, 'YYYY-MM-DD h:mm');
        const storeCloseTime = moment(
          date + ' ' + closeHour,
          'YYYY-MM-DD h:mm'
        );
        let plusQuarter = openHour;
        let middleHoure;
        let range;
        let subQuarter = moment(storeCloseTime)
          .subtract(15, 'minutes')
          .format('H:mm');
        //   let plusQuarter = moment(storeOpenTime).add(15, 'minutes').format('H:mm');
        //   let subQuarter = moment(storeCloseTime)
        //     .subtract(15, 'minutes')
        //     .format('H:mm');
        do {
          middleHoure = moment(storeOpenTime).add(15, 'minutes').format('H:mm');
          range = `${plusQuarter}-${middleHoure}`;
          // console.log(range);
          // console.log(day);
          let now = moment().format('H:mm');
          //   console.log(plusQuarter);
          //   console.log(now);
          let before = moment(plusQuarter, 'H:mm').isBefore(
            moment(now, 'H:mm'),
            'minutes'
          );
          let today = moment().format('dddd').toLowerCase();
          //   console.log(today);
          if (day === today) {
            if (!before) {
              quarteHours[day].push(range);
            }
          } else {
            quarteHours[day].push(range);
          }

          plusQuarter = middleHoure;
          storeOpenTime = moment(date + ' ' + middleHoure, 'YYYY-MM-DD h:mm');
        } while (plusQuarter !== subQuarter);
      });
    }
  }

  //   console.log(openHours);
  //   console.log(quarteHours);
  const handleDateChange = e => {
    setSelectedJour(e.target.value);
    setOrderTime(post.id, e.target.value, null);
  };
  const handleTimeChange = e => {
    setOrderTime(post.id, time.jour, e.target.value);
  };
  var daysOfWeek = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ];
  var d = new Date();
  var dayName = daysOfWeek[d.getDay()];
  //////////////////////////////////////////

  return (
    <Box
      pl={['3%', '3%', '10%', '10%']}
      pr={['3%', '3%', '10% ', '10%']}
      mt="92.43px"
    >
      <Head title={post && post.name}></Head>

      <SimpleGrid rounded="15px" shadow="lg" mb="50px" columns={[1, 1, 2, 2]}>
        <Box bg="white">
          <Flex justifyContent="flex-end">
            {!auth.data && !auth.loading ? (
              <NotLoggedinHeart></NotLoggedinHeart>
            ) : (
              <LoggedinHeart></LoggedinHeart>
            )}
            {/* {JSON.stringify(isfaved)} */}
          </Flex>

          <Box pr="20px" pl="20px" mt="4">
            <Heading color="red.500">{post && post.name}</Heading>
            <Flex justifyContent="space-between">
              <Box w="50%">
                <Text color="gray.600"> {post && post.adress} </Text>
                <Text color="gray.400">
                  {' '}
                  {distance && distance.toFixed(1) + ' km'}
                </Text>
              </Box>
              <Box ml="50px" color="gray.500">
                <Box d="flex" mt="2" alignItems="center">
                  <ReactStars
                    value={Rate}
                    edit={false}
                    count={5}
                    size={20}
                    activeColor="#ffd700"
                  />
                </Box>
                <Box color="red.500" mt="2" display="flex">
                  {post &&
                    post.prix !== null &&
                    [...Array(Number(post.prix))].map(() => (
                      <FaEuroSign></FaEuroSign>
                    ))}
                </Box>
                {/* <Box color="gray.600" mt="2">
                  {post.categories[0] && (
                    <Text>
                      {post.categories.map((cat) => {
                        return cat.name + ',  ';
                      })}
                    </Text>
                  )}
                </Box> */}
              </Box>
            </Flex>
          </Box>
          <Box mt="4" pr="20px" pl="20px">
            <a
              rel="noreferrer"
              target="_blank"
              href={`https://www.google.com/maps/search/?api=1&query=${
                post && post.latitude
              },${post && post.longitude}`}
            >
              <Button
                _hover={{ bg: 'red.700' }}
                mr="4"
                mb="4"
                rounded="20px"
                bg="red.500"
                color="white"
              >
                afficher les itinéraires
              </Button>
            </a>
            <InfoHoraire post={post}></InfoHoraire>
          </Box>
          <Box mt="20px" pr="20px" pl="20px">
            <Text fontSize="2xl" color="gray.600">
              Choisissez votre fenêtre de retrait{' '}
            </Text>
            <Box
              rounded="15px"
              mb="30px"
              mt="10px"
              textAlign="center"
              bg="red.500"
              w="100%"
              p={4}
              color="white"
            >
              Les horaires sont variables, ils seront confirmés lors de la
              validation de votre commande.
            </Box>
          </Box>
          <Box
            d="flex"
            flexDirection={['column', 'column', 'row', 'row']}
            mt="20px"
            pr="30px"
            pl="30px"
            mb="30px"
          >
            <FormControl m="2" w={['100%', '100%', '50%', '50%']}>
              <Select
                className="main-search"
                shadow="lg"
                rounded="20px"
                color="gray.500"
                // defaultValue={date}
                onChange={handleDateChange}
                placeholder="Select the day"
              >
                {days &&
                  days.map(day => (
                    <>
                      <option
                        style={{ color: day === dayName && 'red' }}
                        value={day}
                      >
                        {day}
                      </option>
                    </>
                  ))}
              </Select>
            </FormControl>
            {selectedJour && (
              <FormControl m="2" w={['100%', '100%', '50%', '50%']}>
                {/* <FormLabel color="gray.600"> working hours </FormLabel> */}
                <Select
                  className="main-search"
                  shadow="lg"
                  rounded="20px"
                  color="gray.500"
                  //   defaultValue={timing}
                  onChange={handleTimeChange}
                  placeholder="Select time range"
                >
                  {quarteHours[selectedJour].map(clock => (
                    <>
                      <option value={clock}>{clock}</option>
                    </>
                  ))}
                </Select>
              </FormControl>
            )}
          </Box>
        </Box>
        <Box
          position="relative"
          style={{
            background: ` linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('${process.env.REACT_APP_API}/storage/${post && post.image}')`,
          }}
          className="detail-image"
        >
          {!restOpen ? (
            <Tag
              p="2"
              d={['none', 'none', 'block', 'block']}
              position="absolute"
              bottom="30px"
              right="30px"
              rounded="20px"
              fontSize="2xl"
              bg="red.100"
              color="red.500"
            >
              fermé
            </Tag>
          ) : (
            <Tag
              p="2"
              d={['none', 'none', 'block', 'block']}
              position="absolute"
              bottom="30px"
              right="30px"
              rounded="20px"
              bg="green.100"
              color="green.500"
              fontSize="2xl"

              // variant="outline"
            >
              ouvert
            </Tag>
          )}
        </Box>
      </SimpleGrid>
      {true ? (
        <Plat post={post}></Plat>
      ) : (
        <Box p="40px" bg="white" width="100%">
          <Box display="flex" justifyContent="center">
            <Open></Open>
          </Box>
          <Box mt="20px" textAlign="center">
            <Heading color="gray.400">
              le restaurant est fermé pour le moment{' '}
            </Heading>
          </Box>
        </Box>
      )}
      <Box
        p="30px"
        mt="50px"
        bg="white"
        color="black"
        rounded="15px"
        shadow="lg"
      >
        <FormControl>
          <FormLabel>Commentaire</FormLabel>
          <Textarea
            value={reviewObject.review}
            onChange={handleReviewComment}
            border="1px solid black"
            borderColor="black"
            placeholder="écrire un commentaire "
          ></Textarea>
        </FormControl>
        <ReactStars
          count={5}
          onChange={ratingChanged}
          size={30}
          activeColor="#ffd700"
        />
        <Flex justifyContent="flex-end">
          <Button
            onClick={async () => {
              if (!auth.data) {
                toast({
                  position: 'top-right',
                  title: 'You are not logged in',
                  description: 'You must log in to add a review',
                  status: 'info',
                  duration: 4000,
                  isClosable: true,
                });
              } else {
                await addReview(reviewObject);
                setReviews(prev => [...prev, { ...reviewObject }]);
                setReview({ rate: '', review: '', restaurant_id: post.id });
                toast({
                  position: 'top-right',
                  title: 'review addes successfuly',

                  status: 'success',
                  duration: 4000,
                  isClosable: true,
                });
              }
            }}
            type="submit"
            isDisabled={reviewObject.review === '' || reviewObject.rate === ''}
            isLoading={review.loading}
            _hover={{ bg: 'red.700' }}
            bg="red.500"
            color="white"
          >
            {' '}
            Submit
          </Button>
        </Flex>
        <Box mt="8">
          {reviews &&
            reviews.map(review => (
              <Box
                rounded="20px"
                p="10px"
                m="2"
                bg="gray.100"
                key={review.id || 2545}
              >
                <ReactStars
                  value={review.rate}
                  count={5}
                  edit={false}
                  size={20}
                  activeColor="#ffd700"
                />
                <Text>{review.review}</Text>
              </Box>
            ))}
        </Box>
      </Box>
    </Box>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    AddFavory: id => dispatch(AddFavory(id)),
    AlgoSearch: id => dispatch(AlgoSearch(id)),
    deleteFavory: id => dispatch(deleteFavory(id)),
    getRestaurant: id => dispatch(getRestaurant(id)),
    getFavories: () => dispatch(getFavories()),
    addReview: review => dispatch(addReview(review)),
    setOrderTime: (restId, day, hour) =>
      dispatch(setOrderTime(restId, day, hour)),
  };
};

const mapStateToProps = state => {
  return {
    rest: state.rest,
    post: state.rest.post,
    position: state.location,
    auth: state.auth,
    review: state.review,
    time: state.orderTime,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Restaurant);
